jQuery(function($){
  var $window = $(window);
  var $bandaiContent = $(".bandai-box");
  var $bandaiBtnsPC = $(".bandai-btns .bandai--btn");
  var $bandaiBtnsSP = $bandaiContent.find(".bandai--btn");
  var _isSP = false;

  var ContentAppearPC = function(event){
    var _$this = $(event.currentTarget);
    var _taregetotonaContent = "bandai-box" + _$this.data("target");
    if(_$this.hasClass("bandai--btn-current")){
      return;
    }
    $bandaiContent.each(function(){
      var __$this = $(this);
      if(__$this.hasClass(_taregetotonaContent)){
        __$this.addClass("bandai-box-open");
      }else{
        __$this.removeClass("bandai-box-open");
      }
    });

    $bandaiBtnsPC.each(function(i){
      var __$this = $(this);
      __$this.removeClass("bandai--btn-current");
      if(i === (parseInt(_$this.data("target")) - 1)){
        __$this.addClass("bandai--btn-current");
      }
    });
  };

  var ContentAppearSP = function(event){
    var _$this = $(event.currentTarget);
    var _$parent = _$this.parent();
    var _$contentWrap = _$parent.find(".bandai-content-wrap");
    _$contentWrap.stop().slideToggle(function(){
      if(_$parent.hasClass("bandai-box-open") && _$contentWrap.css("display") === "none"){
        _$parent.removeClass("bandai-box-open")
      }else{
        _$parent.addClass("bandai-box-open")
      }
    });
  };

  $bandaiBtnsPC.each(function(){
    $(this).on("click", ContentAppearPC);
  });
  $bandaiBtnsSP.each(function(){
    $(this).on("click", ContentAppearSP);
  });

  var CurrentSetPC = function(num){
    $bandaiBtnsPC.each(function(i){
      var __$this = $(this);
      if(i === num){
        $($bandaiContent[i]).addClass("bandai-box-open");
        __$this.addClass("bandai--btn-current");
      }else{
        $($bandaiContent[i]).removeClass("bandai-box-open");
        __$this.removeClass("bandai--btn-current");
      }
    });
  };

  var Resizer = function(){
    if($window.width() > 750){
      if(_isSP){
        _isSP = false;
        var _$open = $(".bandai-box-open");
        $bandaiContent.each(function(){
          $(this).find(".bandai-content-wrap").css({display: ""});
        });
        if(_$open.length === 0){
          CurrentSetPC(0);
        }else{
          var _taregetNum = parseInt($(_$open[0]).find(".bandai--btn").data("target")) - 1;
          CurrentSetPC(_taregetNum);
        }
      }
    }else{
      if(!_isSP){
        _isSP = true;
        // SP
      }
    }
  };

  $window.on("resize", Resizer);
  Resizer();
});